<template>
  <div>
      <v-row justify="center" alignment="center" no-gutters>
          <v-col cols="8" class="text-green mid-size text-center padded" v-html="introText">
          </v-col>
      </v-row>
      <v-row justify="center" no-gutters>
          <v-img
            contain
            :src="enBg.src"
            ></v-img>
      </v-row>
  </div>
</template>

<script>
  export default {
    props: ['langData'],
    created() {
      if(window.location.origin == 'https://arlanl.promonow.io' || window.location.origin == 'https://staging.arlanl.promonow.io') {
          this.enBg = {src:require('../assets/whereToFindNl.png')}
      }
    },
    data: (el = this) => ({
      name : 'where',
      heading: el.langData.where.title,
      introText: el.langData.where.body,
      enBg: {src:require('../assets/whereToFind.png')},
      lashesRight : {src:require('../assets/lashesRight.png')},
      lashesLeft : {src:require('../assets/lashesLeft.png')},
      lashHeight: '54px',
      nl: false
    })
  }
</script>